<div
  #cookie
  class="cookie"
  fxLayout="row wrap"
  fxLayoutAlign="center center"
  (window:resize)="onResize()"
>
  <label>
    {{
      localeService.getCurrentLocale() === 'ro'
      ? 'Acest website foloseste cookie-uri pentru a furniza vizitatorilor o experiență mult mai bună de navigare și servicii adaptate nevoilor și interesului fiecăruia.'
      : 'This site uses cookies. Continuing browsing this site represents your agreement to the use of cookies in order to ensure the best user experience and services, tailored for every user.'
    }}
  </label>
  <div>
    <button
      *ngIf="canDecline"
      (click)="cookieConsentService.setConsent(false); closeCookie()"
    >
      {{ localeService.getCurrentLocale() === 'ro' ? 'Refuză' : 'Decline' }}
    </button>
    <button
      (click)="cookieConsentService.setConsent(true); closeCookie()"
      mat-button
      color="transparent"
      class="accept"
    >
      {{ localeService.getCurrentLocale() === 'ro' ? 'ACCEPTĂ' : 'ACCEPT' }}
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/common-theme/utils/cookie/cookie.component.html